module.exports = __webpack_public_path__ + "static/img/640.9bea33df.webp";